import React, { useCallback } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import { NotificationManager } from '@atlas/core';
import { Icon, Label } from '@atlas/ui';

const STATUS_ICON = {
  error: 'error',
  info: 'info',
  success: 'success-bold',
  warning: 'warning',
};

const ToastCard = props => {
  const { data, id, message, status = 'success', title } = props;

  const onClose = useCallback(() => NotificationManager.removeNotification(id), [id]);

  const iconName = STATUS_ICON[status] || STATUS_ICON.success;

  return (
    <div className={classnames('toast-card', `toast-card--${status}`)}>
      <Icon className="toast-card__icon" name={iconName} />

      <div className="toast-card__body">
        {title ? <Label className="toast-card__title" message={title} params={data} /> : null}
        {message ? <Label className="toast-card__message" message={message} params={data} /> : null}
      </div>

      <Icon className="toast-card__close" name="close" onClick={onClose} />
    </div>
  );
};

ToastCard.propTypes = {
  data: PropTypes.object,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  message: PropTypes.string,
  status: PropTypes.oneOf(['success', 'error', 'warning', 'info']),
  title: PropTypes.string,
};

export default ToastCard;
